export const currencies = [
  { value: 'USD', label: 'USD' },
  { value: 'CAD', label: 'CAD' },
  { value: 'EUR', label: 'EUR' },
  { value: 'GBP', label: 'GBP' },
  // { value: "JPY", label: "JPY" },
  // { value: "MXN", label: "MXN" },
  // { value: "PLN", label: "PLN" },
  // { value: "SEK", label: "SEK" },
];
